import Vue from 'vue'
import { snakeCase } from 'change-case'
import EventBus from '../_event-bus'

const INITIAL_MAX = 4000

Vue.component('vue-prize-filters', {
  template: '#vue-prize-filters-template',
  props: {
    availabilityFilter: Boolean,
    categoryFilters: Object,
    rangeFilters: Object,
  },
  data() {
    return {
      aflo: true,
      afloCategories: [],
      afloRange: [10, INITIAL_MAX + 1],
      afloRangeMax: INITIAL_MAX + 1,
      availability: false,
      edu: true,
      eduCategories: [],
      eduRange: [10, INITIAL_MAX + 1],
      eduRangeMax: INITIAL_MAX + 1,
    }
  },
  updated() {
    EventBus.$emit('filter-prizes', {
      availability: this.availability,
      aflo: this.aflo,
      afloCategories: this.afloCategories,
      afloRange: this.afloRange,
      afloRangeMax: this.afloRangeMax,
      edu: this.edu,
      eduCategories: this.eduCategories,
      eduRange: this.eduRange,
      eduRangeMax: this.eduRangeMax,
    })
  },
  methods: {
    addInitFiltersLiseners,
    addLazyLoadLisetner,
    setCategories,
    updateCategories,
  },
  mounted() {
    this.addInitFiltersLiseners()
    this.addLazyLoadLisetner()
  },
})

function addInitFiltersLiseners() {
  EventBus.$on('init-prize-filters', this.setCategories)
}

function addLazyLoadLisetner() {
  EventBus.$on('load-items', this.updateCategories)
}

function getCategoriesReducer(type) {
  return (acc, { category, pointsType }) => {
    if (!category.length || pointsType !== type || acc.find(filter => filter.label === category))
      return acc

    return [
      ...acc,
      {
        key: snakeCase(category),
        label: category,
        status: true,
      },
    ]
  }
}

function setCategories(prizes) {
  if (this.$props.categoryFilters.aflo) {
    this.afloCategories = prizes.reduce(getCategoriesReducer('aflo'), [])
  }

  if (this.$props.categoryFilters.edu) {
    this.eduCategories = prizes.reduce(getCategoriesReducer('edu'), [])
  }
}

function updateCategories(items) {
  this.items = items
}
